import { Box, Image, FormLabel, HTMLWrapper } from "@/storybook-components";
import { buildImgixUrl } from "@/lib";
import type { Question } from "@/types";

interface ImageQuestionProps {
  question: Question;
}

const ImageQuestion = ({ question }: ImageQuestionProps): JSX.Element => {
  return (
    <Box my={4}>
      <FormLabel>
        <HTMLWrapper html={question.question} />
      </FormLabel>
      <Image
        src={
          question.useImageLink
            ? question.imageUrl
            : buildImgixUrl(question.imageUrl)
        }
        alt={question.question}
      />
    </Box>
  );
};

export default ImageQuestion;
